function geolocationErrorMessage(error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            return 'Location permission was denied. You can allow location access in your browser or enter coordinates manually.';
        case error.POSITION_UNAVAILABLE:
            return 'Your current location could not be determined. Try again outdoors or enter coordinates manually.';
        case error.TIMEOUT:
            return 'Getting your location took too long. Try again or enter coordinates manually.';
        default:
            return 'Your current location could not be retrieved. Enter coordinates manually if needed.';
    }
}

function initLandmarkLocationButtons() {
    document
        .querySelectorAll('[data-landmark-use-location]')
        .forEach((button) => {
            if (button.dataset.landmarkLocationReady === 'true') {
                return;
            }

            button.dataset.landmarkLocationReady = 'true';

            button.addEventListener('click', () => {
                const form = button.closest('form');
                const latitude = form?.querySelector('[data-landmark-latitude]');
                const longitude = form?.querySelector('[data-landmark-longitude]');
                const status = button
                    .parentElement
                    ?.querySelector('[data-landmark-location-status]');

                if (!latitude || !longitude) {
                    return;
                }

                if (!navigator.geolocation) {
                    if (status) {
                        status.textContent =
                            'This browser does not support automatic location. Enter the coordinates manually.';
                    }

                    return;
                }

                button.disabled = true;
                const originalLabel = button.textContent;
                button.textContent = 'Getting Location…';

                if (status) {
                    status.textContent =
                        'Requesting your device location. Your browser may ask for permission.';
                }

                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        latitude.value =
                            position.coords.latitude.toFixed(7);
                        longitude.value =
                            position.coords.longitude.toFixed(7);

                        latitude.dispatchEvent(
                            new Event('input', {
                                bubbles: true,
                            })
                        );
                        longitude.dispatchEvent(
                            new Event('input', {
                                bubbles: true,
                            })
                        );

                        if (status) {
                            const accuracy = Math.round(
                                position.coords.accuracy
                            );

                            status.textContent =
                                `Location filled automatically. Estimated accuracy: about ${accuracy} meters. Review the point before saving.`;
                        }

                        button.disabled = false;
                        button.textContent = originalLabel;
                    },
                    (error) => {
                        if (status) {
                            status.textContent =
                                geolocationErrorMessage(error);
                        }

                        button.disabled = false;
                        button.textContent = originalLabel;
                    },
                    {
                        enableHighAccuracy: true,
                        timeout: 15000,
                        maximumAge: 0,
                    }
                );
            });
        });
}

document.addEventListener(
    'DOMContentLoaded',
    initLandmarkLocationButtons
);

document.addEventListener(
    'livewire:navigated',
    initLandmarkLocationButtons
);
